import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	permissionCheckLink: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.goals.permission-check-link',
		defaultMessage: 'Request or confirm Atlas access.',
		description: 'Link prompting user to visit Atlas',
	},
});
